export const SIDEBAR_LAYOUT_STORAGE_KEY = "tribunalea:suite-sidebar-layout";
const SIDEBAR_LAYOUT_COOKIE_KEY = "tribunalea_suite_sidebar_layout";
const SIDEBAR_LAYOUT_COOKIE_MAX_AGE_SECONDS = 180 * 24 * 60 * 60;
const SIDEBAR_LAYOUTS = new Set(["collapsible", "fixed"]);

export function defaultSidebarLayout(width) {
  return Number(width) < 1440 ? "collapsible" : "fixed";
}

function validSidebarLayout(value) {
  return SIDEBAR_LAYOUTS.has(value) ? value : null;
}

function cookieValue(cookie = "") {
  const entry = String(cookie)
    .split(";")
    .map((part) => part.trim())
    .find((part) => part.startsWith(`${SIDEBAR_LAYOUT_COOKIE_KEY}=`));
  if (!entry) return null;
  try {
    return validSidebarLayout(decodeURIComponent(entry.split("=").slice(1).join("=")));
  } catch {
    return null;
  }
}

export function readSidebarLayoutPreference({
  cookie = typeof document !== "undefined" ? document.cookie : "",
  storage = typeof window !== "undefined" ? window.localStorage : null,
} = {}) {
  const shared = cookieValue(cookie);
  if (shared) return shared;
  try {
    return validSidebarLayout(storage?.getItem(SIDEBAR_LAYOUT_STORAGE_KEY));
  } catch {
    return null;
  }
}

export function persistSidebarLayoutPreference(layout, {
  documentObject = typeof document !== "undefined" ? document : null,
  hostname = typeof window !== "undefined" ? window.location.hostname : "",
  protocol = typeof window !== "undefined" ? window.location.protocol : "",
  storage = typeof window !== "undefined" ? window.localStorage : null,
} = {}) {
  const next = validSidebarLayout(layout);
  if (!next) return;
  try {
    storage?.setItem(SIDEBAR_LAYOUT_STORAGE_KEY, next);
  } catch {
    // Browsers can block local storage while still allowing the app to run.
  }
  if (!documentObject) return;
  const sharedDomain = hostname === "tribunalea.com"
    || hostname.endsWith(".tribunalea.com")
    ? "; Domain=.tribunalea.com"
    : "";
  const secure = protocol === "https:" ? "; Secure" : "";
  documentObject.cookie = `${SIDEBAR_LAYOUT_COOKIE_KEY}=${encodeURIComponent(next)}`
    + `; Path=/; Max-Age=${SIDEBAR_LAYOUT_COOKIE_MAX_AGE_SECONDS}`
    + `; SameSite=Lax${secure}${sharedDomain}`;
}
